<button mat-icon-button test-id="sort-button" [fwTooltip]="tooltip$ | async" [matMenuTriggerFor]="sortMenu">
  <mat-icon>sort</mat-icon>
</button>
<mat-menu #sortMenu>
  @if (value$ | async; as value) {
    <div class="mat-select-panel session-sort-select-panel" (click)="$event.stopPropagation()">
      @for (level of options; track level) {
        <mat-optgroup>
          <mat-label>Sort {{ level.value | titlecase }}</mat-label>
          @for (option of level.options; track option) {
            <mat-option
              [ngClass]="{ selected: value[level.value].active === option.value }"
              (click)="selectSortOption(level.value, option.value)"
            >
              <span>{{ sortCategoryTitles[option.value] }}</span>
              @if (value[level.value].active === option.value) {
                <fw-sort-icon [field]="option.value" [sort]="value[level.value]" />
              }
            </mat-option>
          }
        </mat-optgroup>
      }
    </div>
  }
</mat-menu>
